export const actionTypes = {
    FetchAsinAnalysis: "[FetchAsinAnalysis] Action",
    UpdateAsinAnalysis: "[UpdateAsinAnalysis] Action",
    FetchSuggestedKeywords: "[FetchSuggestedKeywords] Action",
    UpdateSuggestedKeywords: "[UpdateSuggestedKeywords] Action"
};